//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetCompletenessApiSuccess } from './actions';
import { CompletessInfo } from 'features/Dealers/Performance/Widgets/ProfileCompleteness/state/types';

export interface PerformanceCompletenessState {
    completessInfo?: CompletessInfo
}

const defaultState: PerformanceCompletenessState = {
    completessInfo: undefined
};

type CompletenessAction = ActionGetCompletenessApiSuccess;

function performancecompletenessReducer(state: PerformanceCompletenessState = defaultState, action: CompletenessAction): PerformanceCompletenessState {
    switch (action.type) {
        case ACTIONS.GET_COMPLETENESS_API_SUCCESS:
            {
                return {
                    ...state,
                    completessInfo:  action.completenessInfo
                }
            }
    }
    return {
        ...state
    }
}

export default performancecompletenessReducer;